import universal from 'react-universal-component';

export default universal(() => import('./RequestPassword'));


// WEBPACK FOOTER //
// ./src/app/views/PasswordRequest/index.js